<div class="add-env-wrapper">
  <!-- <h2>Add Environment</h2> -->
  <app-environment-form
      [mode]="'add'" (cancel)="closePop()"                       
      (formSubmitted)="handleFormSubmit($event)">
  </app-environment-form>
</div> 
